
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import CancelError from '../CancelError';
import ProgressBar from '@/components/ProgressBar.vue';
import { VinculoPontoUnidade } from '../types-registro-ponto';

@Component({
  components:{
    ProgressBar,
  },
})
export default class RegistroPontoConfirmationAlmoco extends Vue {
  //#region [ CONSTANTS ]
  readonly SCREEN_TIMEOUT_DURATION = 30000; // 30 seconds
  //#endregion



  //#region [ DATA ]
  promise: {
    resolve: (value: boolean | PromiseLike<boolean>) => void;
    reject: (reason?: any) => void;
  } | null = null;
  screenTimeout: number | null = null;
  vinculo: VinculoPontoUnidade | null = null;
  //#endregion



  //#region [ COMPUTED ]
  get progressBar(): ProgressBar {
    return this.$refs.progressBar as ProgressBar || null;
  }

  get nameVinculo(): string {
    return this.vinculo ? this.vinculo.NRNMVINCULO : '';
  }
  //#endregion



  //#region [ EVENTS ]
  @Emit('yes')
  emitYes(): void {}

  @Emit('no')
  emitNo(): void {}

  @Emit('cancel')
  emitCancel(): void {
    if (this.promise) {
      this.promise.reject(new CancelError());
      this.promise = null; // Reset after rejecting
    }
  }
  //#endregion



  //#region [ LIFECYCLE ]
  beforeDestroy() {
    this.clearScreenTimeout();
  }
  //#endregion



  //#region [ METHODS ]
  ask(vinculo: VinculoPontoUnidade): Promise<boolean> {
    this.vinculo = vinculo;
    this.startScreenTimeout(this.SCREEN_TIMEOUT_DURATION);
    this.progressBar.start(this.SCREEN_TIMEOUT_DURATION);

    return new Promise((resolve, reject) => {
      this.promise = {
        resolve,
        reject,
      };
    });
  }

  solvePromise(value: boolean): void {
    if (this.promise) {
      this.promise.resolve(value);
      this.promise = null;
    }
  }

  answer(almoco: boolean): void {
    this.clearScreenTimeout();

    if (almoco) {
      this.emitYes();
    } else {
      this.emitNo();
    }

    this.solvePromise(almoco);
  }

  startScreenTimeout(duration: number): void {
    this.clearScreenTimeout();

    this.screenTimeout = window.setTimeout(() => {
      this.emitCancel();
      this.screenTimeout = null;
    }, duration);
  }

  clearScreenTimeout(): void {
    if (this.screenTimeout) {
      window.clearTimeout(this.screenTimeout);
      this.screenTimeout = null;
    }
  }
  //#endregion
}
